export default __webpack_public_path__ + "static/media/popup-update.ec334288.svg";